export const isStepBeforeAnotherStep = ({ steps, stepToCheckIfBehind, stepToCheckIfAhead, }) => {
    const stepToCheckIfBehindIndex = steps.findIndex(({ step }) => step === stepToCheckIfBehind);
    const stepToCheckIfAheadIndex = steps.findIndex(({ step }) => step === stepToCheckIfAhead);
    if (stepToCheckIfBehindIndex < stepToCheckIfAheadIndex) {
        return true;
    }
    return false;
};
